<template>
    <div>
        <el-dialog title="不合格项"
        v-loading="loading"
        :before-close="beforeClose"
        width="60%"
        :modal-append-to-body="false"
        :visible.sync="visible">
            <avue-crud
                :data="data"
                ref="crud"
                :option="unqualifiedOption"
                @current-change="currentChange"
                @size-change="sizeChange"
                :page.sync="page"

               >
            </avue-crud>
        </el-dialog>
    </div>
</template>
<script>
import {negativeList} from "@/api/crmedical/examine/examinereport";
import {unqualifiedOption} from "./examinereport-form-option";
export default {
    data(){
        return{
            loading:true,
            visible:false,
            page: {
                size: 10,
                current: 1,
                id:'',
                total: 0,

            },
            projectId:'',
            unqualifiedOption:unqualifiedOption,
            data:[],
            details:{},
        }
    },
    methods:{
        // 获取考核列表传入的数据
        setdata(data){
           this.visible = true;
           this.data = [];
            console.log(data)
           this.projectId = data.projectId;
           this.page = {
                size: 10,
                current: 1,
                total: 0,
                id:data.id
            }
            this.onLoad(this.page)


        },
        beforeClose(done){
            this.$emit('update:visible',false);
            done();
        },
        currentChange(current) {
            this.page.current = current;
            this.onLoad()
          },
        sizeChange(size) {
            this.page.size = size;
             this.page.current = 1;
            this.onLoad()
          },
        onLoad(page) {

            page = page || {
                size:this.page.size,
                current:this.page.current,
                id:this.page.id,

            };

            this.loading = true;
            console.log(page)
            negativeList(page).then(({data}) => {
              this.page.total = data.total;
              data.records.forEach(ele=>{
                  ele.projectId = this.projectId
              })
              this.data = data.records;
              this.loading = false;

            }).catch(err=>{
                 this.loading = false;
            })
          }
    }

}
</script>
